import React from "react";
import { useState } from "react";
import { signOut } from "aws-amplify/auth";
import { useAuth } from "./AuthContext";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";



const AccessDenied = () =>{
    const {logout} =  useAuth();
    const [showAccessDenied,setShowAccessDenied] = useState(true);

    const handleAccessDeniedClose = async () => {
        setShowAccessDenied(false);
        try {
            logout();
            // Sign out the user
            await signOut({global:true});
        
        } catch (error) {
            console.error("Error signing out:", error);

        }
    };

    return (
        <>
            <Dialog
                open={showAccessDenied}
                onClose={(event, reason) => {
                    // Prevent closing on backdrop click or escape
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        handleAccessDeniedClose();
                    }
                }}
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ color: '#002244', fontWeight: 'bold' }}>
                    Access Denied
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        You don't have required permissions to access the application, please contact your employer.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleAccessDeniedClose}
                        sx={{
                            backgroundColor: '#002244',
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: '#003366'
                            }
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );


}

export default AccessDenied;